/* ============================================================================
   NAC · NUTRICOST — comportamiento propio del landing, portado 1:1.
   Solo lo visual: el acordeón de preguntas, el comparador antes/después y el
   reveal al hacer scroll. Toda la lógica del formulario COD del landing de
   Vercel queda fuera a propósito — en Shopify compra Releasit.
   ============================================================================ */
(function () {
  if (window.__nacInit) return;
  window.__nacInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- acordeón de preguntas -------------------------------------------- */
  function initFaq(root) {
    root.querySelectorAll('.nac-page .qa > button').forEach(function (btn) {
      if (btn.dataset.nacListo) return;
      btn.dataset.nacListo = '1';
      btn.addEventListener('click', function () {
        var qa = btn.closest('.qa');
        var ans = qa.querySelector('.ans');
        var abierta = qa.classList.contains('open');
        // Se cierra cualquier otra: una sola respuesta abierta a la vez.
        document.querySelectorAll('.nac-page .qa.open').forEach(function (o) {
          o.classList.remove('open');
          var a = o.querySelector('.ans');
          if (a) a.style.maxHeight = null;
        });
        if (!abierta) {
          qa.classList.add('open');
          if (ans) ans.style.maxHeight = ans.scrollHeight + 'px';
        }
      });
    });
  }

  /* --- comparador antes / después ---------------------------------------
     Un input range mueve el recorte del panel "antes" sobre el "después". */
  function initComparador(root) {
    root.querySelectorAll('.nac-page .ba-wrap').forEach(function (wrap) {
      var range = wrap.querySelector('input[type="range"], #baRange');
      var stage = wrap.querySelector('.ba-stage');
      var before = wrap.querySelector('.ba-before');
      if (!range || !stage || !before) return;
      if (range.dataset.nacListo) return;
      range.dataset.nacListo = '1';
      var aplicar = function (v) {
        var clip = (100 - v) + '%';
        before.style.setProperty('--clip', clip);
        stage.style.setProperty('--clip', clip);
      };
      range.addEventListener('input', function () { aplicar(this.value); });
      aplicar(range.value || 50);
    });
  }

  /* --- reveal al hacer scroll -------------------------------------------- */
  function initReveal(root) {
    var items = root.querySelectorAll('.nac-page .reveal');
    if (!items.length) return;

    // Sin animación posible → se deja todo visible y listo.
    if (reduce || !('IntersectionObserver' in window)) return;

    // Recién acá se arma la animación: hasta este punto el CSS mostraba todo.
    document.querySelectorAll('.nac-page').forEach(function (p) { p.classList.add('nac-anim'); });

    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
    items.forEach(function (el) { if (!el.classList.contains('in')) io.observe(el); });

    // Red de seguridad: nada puede quedarse invisible para siempre. Si un
    // elemento nunca dispara el observador (pasa con bloques muy altos o si
    // otro script rompe el scroll), a los 4 segundos se muestra igual.
    setTimeout(function () {
      document.querySelectorAll('.nac-page .reveal:not(.in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 3) el.classList.add('in');
      });
    }, 4000);
  }

  function arrancar(root) {
    initFaq(root);
    initComparador(root);
    initReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { arrancar(document); });
  } else {
    arrancar(document);
  }

  /* El editor de temas re-renderiza secciones sueltas sin recargar. */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
    arrancar(e.target);
  });
})();

/* ============================================================================
   Selector de plan de la oferta (Shopify): la tarjeta elegida escribe la
   variante en el input oculto name="id" y avisa a Releasit del cambio.
   ============================================================================ */
(function () {
  function initPlanes(root) {
    var form = root.querySelector('[data-nac-planes]');
    if (!form) return;
    var oculto = form.querySelector('[data-nac-variante]');
    var tarjetas = form.querySelectorAll('.plan[data-nac-plan]');

    function elegir(id) {
      tarjetas.forEach(function (t) {
        t.classList.toggle('nac-sel', t.getAttribute('data-nac-plan') === id);
      });
      if (oculto && oculto.value !== id) {
        oculto.value = id;
        oculto.dispatchEvent(new Event('change', { bubbles: true }));
        oculto.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    form.querySelectorAll('[data-nac-elegir]').forEach(function (btn) {
      if (btn.dataset.nacListo) return;
      btn.dataset.nacListo = '1';
      btn.addEventListener('click', function () {
        elegir(btn.getAttribute('data-nac-elegir'));
        var zona = form.querySelector('.nac-boton-app');
        if (zona) zona.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initPlanes(document); });
  } else {
    initPlanes(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initPlanes(e.target); });
})();

/* ============================================================================
   Comportamientos del landing que viven fuera de una sección concreta:
   los botones [data-scroll] y la barra fija de móvil.
   ============================================================================ */
(function () {
  function initScroll(root) {
    root.querySelectorAll('.nac-page [data-scroll]').forEach(function (b) {
      if (b.dataset.nacScroll) return;
      b.dataset.nacScroll = '1';
      b.addEventListener('click', function () {
        var t = document.getElementById(b.getAttribute('data-scroll'));
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* La barra fija aparece pasado el hero y se esconde mientras se ve la oferta,
     para no competir con los botones de los planes. */
  function initSticky() {
    var sticky = document.getElementById('stickyBar');
    if (!sticky || sticky.dataset.nacListo) return;
    sticky.dataset.nacListo = '1';
    var hero = document.querySelector('.nac-page .hero');
    var oferta = document.getElementById('oferta');
    function actualizar() {
      var y = window.scrollY;
      var pasoHero = hero ? y > (hero.offsetHeight - 80) : y > 400;
      var enOferta = oferta && (y + window.innerHeight) > oferta.offsetTop && y < (oferta.offsetTop + oferta.offsetHeight);
      sticky.classList.toggle('show', pasoHero && !enOferta);
    }
    window.addEventListener('scroll', actualizar, { passive: true });
    actualizar();
  }

  function arrancar() { initScroll(document); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
  document.addEventListener('shopify:section:load', function (e) { initScroll(e.target); initSticky(); });
})();
